import { createBrowserRouter } from "react-router-dom";
import { Route404Page } from "@songtradr-sso/shared/frontend";
import { AppLayout } from "../layouts/App.Layout";
import { ForwardAuthLayout } from "../layouts/forward-auth/ForwardAuth.Layout";
import { MfaLayout } from "../layouts/mfa/Mfa.Layout";
import { EmailConfirmationRouteObject } from "../pages/email-confirmation/EmailConfirmation.Route";
import { MfaSmsVerifyRouteObject } from "../pages/mfa/sms-verify/MfaSmsVerify.Route";
import { MfaTotpVerifyRouteObject } from "../pages/mfa/totp-verify/MfaTotpVerify.Route";
import { OauthCallbackRouteObject } from "../pages/oauth-callback/OauthCallback.Route";
import { ConfirmPasswordRouteObject } from "../pages/password-recovery/confirm-password/ConfirmPassword.Route";
import { ForgotPasswordRouteObject } from "../pages/password-recovery/forgot-password/ForgotPassword.Route";
import { SignInRouteObject } from "../pages/sign-in/SignIn.Route";
import { SignOutRouteObject } from "../pages/sign-out/SignOut.Route";
import { SignUpRouteObject } from "../pages/sign-up/SignUp.Route";
import { WorkspaceCaptureRouteObject } from "../pages/workspace-capture/WorkspaceCapture.Route";

export const router = createBrowserRouter([
  SignOutRouteObject,
  {
    ...AppLayout,
    children: [
      {
        ...ForwardAuthLayout,
        children: [
          WorkspaceCaptureRouteObject,
          SignInRouteObject,
          SignUpRouteObject,
        ],
      },
      {
        ...MfaLayout,
        children: [MfaTotpVerifyRouteObject, MfaSmsVerifyRouteObject],
      },
      ForgotPasswordRouteObject,
      ConfirmPasswordRouteObject,
      EmailConfirmationRouteObject,
      OauthCallbackRouteObject,
      {
        path: "*",
        element: <Route404Page />,
      },
    ],
  },
]);
